var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-label"},[_c('div',{staticClass:"label",class:_vm.progress['value']},[_vm._v("\n    "+_vm._s(_vm.progress['label'])+" \n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }